<template>
	<TransitionRoot
		:show="true"
		:as="`h${level}`"
		class="text-2xl/8 font-semibold text-zinc-950 sm:text-xl/8 dark:text-white">
		<slot />
	</TransitionRoot>
</template>

<script lang="ts">
	export default { name: 'VHeading' } // name the component
</script>

<script setup lang="ts">
	import {
		TransitionRoot
	} from '@headlessui/vue'

	// eslint-disable-next-line
	const props = defineProps({
		level: {
			type: Number,
			default: 1
		}
	})
</script>